const videoBlocks = document.querySelectorAll('[data-behaviour="video-block"]');

if (videoBlocks.length > 0) {
    videoBlocks.forEach((videoBlock) => {
        videoBlock.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            videoBlock.classList.add('playing');
            const id = videoBlock.dataset.video;
            const iframe = videoBlock.querySelector('iframe');
            iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1';
            document.body.classList.add('video-playing');

            const handleDocumentClick = (event) => {
                if (!event.target.closest('[data-behaviour="video-block"]')) {
                    document.body.classList.remove('video-playing');
                    videoBlock.classList.remove('playing');
                    iframe.src = '';
                    document.removeEventListener('click', handleDocumentClick);
                }
            };

            document.addEventListener('click', handleDocumentClick);
        });
    });
}
